<template>
    <div class="container is-max-widescreen has-bg-white py-5">
        <Header/>
        <div>
            <div class="has-background-white rounded-top-2 p-3">
                <h3 class="is-size-3">{{$t('import_history')}}</h3>
                <div v-html="$t('import_history_info_text')"></div>
            </div>
            <div class="list-body has-background-white">
                <div class="p-2">
                    <b-table
                        :data="data"
                        bordered
                        :sticky-header="true"
                        class="import-history-table"
                        >

                        <b-table-column  :label="$t('file_name')" v-slot="props">
                            {{ props.row.original_file_name }}
                        </b-table-column>

                        <b-table-column  :label="$t('import_date')" v-slot="props">
                            {{ formatDate(props.row.date_created) }}
                        </b-table-column>

                        <b-table-column  :label="$t('import_done_by')" v-slot="props">
                            {{props.row.user_name}} {{props.row.user_surname}}
                        </b-table-column>

                        <b-table-column  :label="$t('total_consent_count')" v-slot="props">
                            {{totalCount([props.row.total_invalids , props.row.total_metas_valids])}}
                        </b-table-column>

                        <b-table-column  :label="$t('ready_to_import_e_government')"  v-slot="props">
                           {{totalCount([props.row.total_metas_valids])}}
                        </b-table-column>

                        <b-table-column  :label="$t('failed_to_import')"  v-slot="props">
                            {{totalCount([props.row.total_invalids])}}
                        </b-table-column>

                        <b-table-column :label="$t('detail')" v-slot="props">
                            <div class="is-flex is-justify-content-space-between is-align-content-center">
                                <b-tooltip :label="$t('ready_to_import_e_government_btn_label')"
                                position="is-left" type="is-light">
                                    <b-icon icon="upload" class="is-clickable" type="is-grey" @click.native="confirmBulkImportTaskF(props.row.sid)"></b-icon>
                                </b-tooltip>
                                <b-tooltip :label="props.row.progress_status=='completed'?$t('export_result_file'):$t('progress_status_is_not_completed')"
                                position="is-left" type="is-light">
                                    <b-icon icon="download" class="is-clickable" :class="{'is-disabled':props.row.progress_status!=='completed'}" type="is-grey" @click.native="props.row.progress_status=='completed'?exportBulkImportTaskDetailsF(props.row.sid):false"></b-icon>
                                </b-tooltip>
                            </div>
                        </b-table-column>

                        <template #bottom-left>
                            
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapActions,mapGetters } from 'vuex'
import Header from './Header'
import { NotificationProgrammatic as Notification } from 'buefy'

export default {
    name:'Home',
    components: {
        Header
    },
    data() {

        return {
            data:[],
            pagingOffset:0,
            pagingSize:10

        }
    },
    computed:{
        ...mapGetters(['bulk_import_tasks'])
    },
    mounted() {
        var table = document.getElementsByClassName('table-wrapper')
        var self = this
        table[0].addEventListener('scroll', function(e){
            const scrollYEmit = Math.ceil(e.target.scrollTop) 
            const clientHeightEmit = e.target.clientHeight
            const scrollHeightEmit = e.target.scrollHeight

            if (scrollYEmit+clientHeightEmit >= scrollHeightEmit) {
            //    self.pagingOffset = self.pagingSize
            //    self.pagingSize = self.pagingSize+self.pagingSize
             
               self.pagingOffset = self.pagingOffset + 10
               self.getBulkImportTasksF('byScroll')
            }
        })
    },
    methods: {
        ...mapActions(['getBulkImportTasks','confirmBulkImportTask','exportBulkImportTaskDetails']),
        translateErrors(arr){
            return arr.map(e => this.$t(e));
        },
        formatDate(date){
            if(date){
                return this.$moment(date).format('DD.MM.YYYY HH:mm')
            }else{
                return ''
            }
        },
        getBulkImportTasksF(emitter){
            // let pagingOffset=0;
            // let pagingSize=5;
            let form = {}
            form.pagingOffset = this.pagingOffset
            form.pagingSize = this.pagingSize

            this.getBulkImportTasks(form).then((response) => {
                console.log('--getBulkImportTasks success response')
                console.log(response)
                if(emitter=='byScroll'){
                    this.data = this.data.concat(this.bulk_import_tasks)
                }else{
                    this.data=this.bulk_import_tasks
                }
                console.log("this.data")
                console.log(this.data)
                
            }).catch(e => {
                console.log('--getBulkImportTasks Error')
                console.log(e)
            })
        },
        confirmBulkImportTaskF(sid){
            let form = {}
            form.sid = sid
            this.confirmBulkImportTask(form).then((response) => {
                console.log('--confirmBulkImportTask success response')
                console.log(response)
                Notification.open({
                    duration: 5000,
                    message: this.$t(response.status.name),
                    position: 'is-top-right',
                    type: 'is-success',
                    hasIcon: true
                })
            }).catch(e => {
                console.log('--confirmBulkImportTask Error')
                console.log(e)
            })
        },
        exportBulkImportTaskDetailsF(sid){
            let form = {}
            form.bulkImportTaskSid = sid
            this.exportBulkImportTaskDetails(form).then((response) => {
                console.log('--exportBulkImportTaskDetails success response')
                console.log(response)
                Notification.open({
                    duration: 5000,
                    message: this.$t(response.status.name),
                    position: 'is-top-right',
                    type: 'is-success',
                    hasIcon: true
                })
                if(response.content.link){
                    window.location.href =response.content.link
                }
            }).catch(e => {
                console.log('--exportBulkImportTaskDetails Error')
                console.log(e)
            })
        },
        totalCount(countList){
            let sum =  countList.reduce((a,b)=> a+b)
            return isNaN(sum)?'-':sum
        }
        
    },
    created() {
        this.getBulkImportTasksF()
    },
}
</script>
<style scoped>
    
    
</style>


// WEBPACK FOOTER //
// src/components/ImportHistory.vue